export abstract class BaseSerializer<T> {
  abstract fromJson(json: any): T;
  abstract toJson(obj: T | Partial<T>): string;
}
